import { Fragment, useReducer, useState } from "react";
import { Dialog, Disclosure, Menu, Transition } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import {
  ChevronDownIcon,
  FunnelIcon,
  MinusIcon,
  PlusIcon,
  Squares2X2Icon,
} from "@heroicons/react/20/solid";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import Pagination from "@mui/material/Pagination";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import PaginationItem from "@mui/material/PaginationItem";

import { filters, singleFilter, sortOptions } from "./FilterData";
import ProductCard from "../ProductCard/ProductCard";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { productdata } from "../../../../data";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import {
  findProducts,
  findProductsByCategory,
} from "../../../../Redux/Customers/Product/Action";
import { deepPurple } from "@mui/material/colors";
import {
  Backdrop,
  Button,
  Checkbox,
  CircularProgress,
  TextField,
  Typography,
} from "@mui/material";
import BackdropComponent from "../../BackDrop/Backdrop";
import { Grid } from "@mui/material";
import HomeProductCard from "../../Home/HomeProductCard";
import Box from "@mui/material/Box";
import Slider from "@mui/material/Slider";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function Product() {
  const [mobileFiltersOpen, setMobileFiltersOpen] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const jwt = localStorage.getItem("jwt");
  const param = useParams();
  const { customersProduct } = useSelector((store) => store);
  const location = useLocation();
  const [isLoaderOpen, setIsLoaderOpen] = useState(false);
  const intialFilters = {
    color: [],
    size: [],
    price: [],
    disccout: [],
    stock: [],
  };
  const [selectedFilters, setSelectedFilters] = useState({ ...intialFilters });
  const [selectedPageNo, setSelectedPageNo] = useState(1);
  const [priceRange, setPriceRange] = useState([0, 50000]);
  const [selectedSort, setSelectedSort] = useState("price_low");
  const [selectedFilteresPagination, setSelectedFilteresPagination] = useState({
    color: [],
    size: [],
    price: [],
    disccout: [],
    stock: [],
  });

  const handleSliderChange = (e, newValue) => {
    setPriceRange(newValue);
  };

  const handleLoderClose = () => {
    setIsLoaderOpen(false);
  };

  const decodedQueryString = decodeURIComponent(location.search);
  const searchParams = new URLSearchParams(decodedQueryString);

  const handleSortChange = (value) => {
    setSelectedSort(value);
    const data = {
      category: query,
      view_all: view_all,
      colors: selectedFilters.color,
      sizes: selectedFilters.size,
      minPrice: priceRange[0],
      maxPrice: priceRange[1],
      minDiscount: 0,
      sort: value,
      pageNumber: 1,
      pageSize: 12,
      stock: selectedFilters.stock.length
        ? selectedFilters.stock[0]
        : "in_stock",
    };
    dispatch(findProducts(data));
  };

  const handlePaginationChange = (event, value) => {
    setSelectedPageNo(value);
    const data = {
      category: query,
      view_all: view_all,
      colors: selectedFilteresPagination.color,
      sizes: selectedFilteresPagination.size,
      minPrice: priceRange[0],
      maxPrice: priceRange[1],
      minDiscount: 0,
      sort: selectedSort,
      pageNumber: value,
      pageSize: 12,
      stock: selectedFilteresPagination.stock.length
        ? selectedFilteresPagination.stock[0]
        : "in_stock",
    };
    dispatch(findProducts(data));
  };

  let view_all = searchParams.get("view_all");

  const query = param.lavelThree;
  useEffect(() => {
    const data = {
      category: query,
      view_all: view_all,
      colors: [],
      sizes: [],
      minPrice: 0,
      maxPrice: 10000,
      minDiscount: 0,
      sort: "price_low",
      pageNumber: 1,
      pageSize: 12,
      stock: "in_stock",
    };
    dispatch(findProducts(data));
  }, [param.lavelThree]);

  useEffect(() => {
    if (customersProduct.loading) {
      setIsLoaderOpen(true);
    } else {
      setIsLoaderOpen(false);
    }
  }, [customersProduct.loading]);

  let newSelectedFilteres = Object.assign({}, selectedFilters);

  const handleFilter = (value, sectionId) => {

    if (sectionId == "stock") {
      newSelectedFilteres[sectionId] = [value];
      setSelectedFilters(newSelectedFilteres);
      return;
    }
    if (!newSelectedFilteres[sectionId].includes(value)) {
      newSelectedFilteres[sectionId].push(value);
      setSelectedFilters(newSelectedFilteres);
    } else if (newSelectedFilteres[sectionId].includes(value)) {
      newSelectedFilteres = {
        ...newSelectedFilteres,
        [sectionId]: selectedFilters[sectionId].filter((item) => item != value),
      };
      setSelectedFilters(newSelectedFilteres);
    }
  };

  const handleApplyFilter = () => {
    const data = {
      category: query,
      view_all: view_all,
      colors: selectedFilters.color,
      sizes: selectedFilters.size,
      minPrice: priceRange[0],
      maxPrice: priceRange[1],
      minDiscount: 0,
      sort: selectedSort,
      pageNumber: 1,
      pageSize: 12,
      stock: selectedFilters.stock.length
        ? selectedFilters.stock[0]
        : "in_stock",
    };
    dispatch(findProducts(data));
    setMobileFiltersOpen(false);
    const selectedPageFilters = JSON.parse(JSON.stringify(selectedFilters));
    setSelectedFilteresPagination(selectedPageFilters);
  };

  const resetFiltersHanlder = () => {
    const data = {
      category: query,
      view_all: view_all,
      colors: [],
      sizes: [],
      minPrice: [],
      maxPrice: [],
      minDiscount: 0,
      sort: "price_low",
      pageNumber: 1,
      pageSize: 12,
      stock: "in_stock",
    };
    dispatch(findProducts(data));
    setSelectedFilters(intialFilters);
    setPriceRange([0, 50000]);
    setMobileFiltersOpen(false);
  };


  const productGridStyle =
    customersProduct?.products[`${query}`]?.content?.length <= 0
      ? {
          gridTemplateColumns: "1fr 4fr",
        }
      : {};

  return (
    <div className="">
      <div>
        {/* Mobile filter dialog */}
        <Transition.Root show={mobileFiltersOpen} as={Fragment}>
          <Dialog
            as="div"
            className="relative z-40 lg:hidden"
            onClose={setMobileFiltersOpen}
          >
            <Transition.Child
              as={Fragment}
              enter="transition-opacity ease-linear duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="transition-opacity ease-linear duration-300"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-black bg-opacity-25" />
            </Transition.Child>

            <div className="fixed inset-0 z-40 flex">
              <Transition.Child
                as={Fragment}
                enter="transition ease-in-out duration-300 transform"
                enterFrom="translate-x-full"
                enterTo="translate-x-0"
                leave="transition ease-in-out duration-300 transform"
                leaveFrom="translate-x-0"
                leaveTo="translate-x-full"
              >
                <Dialog.Panel className="ml-auto flex h-full w-full max-w-xs flex-col  py-4 pb-12 shadow-xl bg-[#FFFBF2] relative">
                  <div className="flex items-center justify-between px-4">
                    <h2 className="text-lg font-medium text-gray-900">
                      Filters
                    </h2>
                    <button
                      type="button"
                      className="-mr-2 flex h-10 w-10 items-center justify-center rounded-md p-2 text-gray-400"
                      onClick={() => setMobileFiltersOpen(false)}
                    >
                      <span className="sr-only">Close menu</span>
                      <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                    </button>
                  </div>

                  {/* Filters */}
                  <form
                    className="mt-4 border-t border-gray-200 overflow-y-auto h-5/6"
                    id="filter-form-desktop"
                    name="filter-form-desk"
                  >
                    {filters.map((section) => (
                      <Disclosure
                        as="div"
                        key={section.id}
                        className="border-gray-200 px-4 py-6"
                        // open={false}
                      >
                        {({ open }) => (
                          <>
                            <h3 className="-mx-2 -my-3 flow-root">
                              <Disclosure.Button className="flex w-full items-center justify-between px-2 py-3 text-gray-400 hover:text-gray-500">
                                <span className="font-medium text-gray-900">
                                  {section.name}
                                </span>
                                <span className="ml-6 flex items-center">
                                  {open ? (
                                    <MinusIcon
                                      className="h-5 w-5"
                                      aria-hidden="true"
                                    />
                                  ) : (
                                    <PlusIcon
                                      className="h-5 w-5"
                                      aria-hidden="true"
                                    />
                                  )}
                                </span>
                              </Disclosure.Button>
                            </h3>
                            <Disclosure.Panel className="pt-6">
                              <div className="space-y-6">
                                {section.id == "price" ? (
                                  <Box sx={{}}>
                                    <Slider
                                      // getAriaLabel={() => "Temperature range"}
                                      value={priceRange}
                                      onChange={handleSliderChange}
                                      valueLabelDisplay="auto"
                                      size="small"
                                      sx={{ color: "#b28585" }}
                                      min={0}
                                      max={50000}
                                      // getAriaValueText={valuetext}
                                    />
                                    <div className="flex gap-2">
                                      <TextField
                                        id="min-price"
                                        name="min"
                                        variant="outlined"
                                        size="small"
                                        defaultValue={0}
                                        value={priceRange[0]}
                                        onChange={(e) => {
                                          setPriceRange([
                                            e.target.value,
                                            priceRange[1],
                                          ]);
                                        }}
                                      />
                                      <TextField
                                        id="max-price"
                                        hiddenLabel
                                        variant="outlined"
                                        size="small"
                                        defaultValue={50000}
                                        value={priceRange[1]}
                                        onChange={(e) => {
                                          setPriceRange([
                                            priceRange[0],
                                            e.target.value,
                                          ]);
                                        }}
                                      />
                                    </div>
                                  </Box>
                                ) : (
                                  section.options.map((option, optionIdx) => (
                                    <div
                                      key={option.value}
                                      className="flex items-center"
                                    >
                                      <input
                                        id={`filter-mobile-${section.id}-${optionIdx}`}
                                        name={`${section.id}[]`}
                                        defaultValue={option.value}
                                        type="checkbox"
                                        className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500 cursor-pointer"
                                        onChange={() =>
                                          handleFilter(option.value, section.id)
                                        }
                                        checked={selectedFilters[
                                          section.id
                                        ].includes(option.value)}
                                      />
                                      <label
                                        htmlFor={`filter-mobile-${section.id}-${optionIdx}`}
                                        className="ml-3 min-w-0 flex-1 text-gray-500"
                                      >
                                        {option.label}
                                      </label>
                                    </div>
                                  ))
                                )}
                              </div>
                            </Disclosure.Panel>
                          </>
                        )}
                      </Disclosure>
                    ))}
                    {singleFilter.map((section) => (
                      <Disclosure
                        // defaultOpen={true}
                        as="div"
                        key={section.id}
                        className="border-gray-200 py-6 px-4"
                      >
                        {({ open }) => (
                          <>
                            <h3 className="-my-3 flow-root">
                              <Disclosure.Button className="flex w-full items-center justify-between py-3 text-sm text-gray-400 hover:text-gray-500">
                                <span className="font-medium text-gray-900">
                                  {section.name}
                                </span>
                                <span className="ml-6 flex items-center">
                                  {open ? (
                                    <MinusIcon
                                      className="h-5 w-5"
                                      aria-hidden="true"
                                    />
                                  ) : (
                                    <PlusIcon
                                      className="h-5 w-5"
                                      aria-hidden="true"
                                    />
                                  )}
                                </span>
                              </Disclosure.Button>
                            </h3>
                            <Disclosure.Panel className="pt-6">
                              {/* <FormControl> */}
                              <RadioGroup
                                aria-labelledby="demo-radio-buttons-group-label"
                                defaultValue="female"
                                name="radio-buttons-group"
                              >
                                {section.options.map((option, optionIdx) => (
                                  <FormControlLabel
                                    sx={{
                                      padding: "0 12px",
                                      fontSize: "14px",
                                    }}
                                    value={option.value}
                                    control={
                                      <input
                                        name="stock"
                                        value={option.value}
                                        type="radio"
                                        checked={selectedFilters[
                                          section.id
                                        ].includes(option.value)}
                                        className="mr-2 h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                                      />
                                    }
                                    label={option.label}
                                    onChange={(e) =>
                                      handleFilter(e.target.value, section.id)
                                    }
                                    className="ml-3 min-w-0 text-sm flex-1 text-gray-500"
                                    // onChange={(e) =>
                                    //   handleRadioFilterChange(e, section.id)
                                    // }
                                  />
                                ))}
                              </RadioGroup>
                              {/* </FormControl> */}
                            </Disclosure.Panel>
                          </>
                        )}
                      </Disclosure>
                    ))}
                  </form>
                  <div className="absolute w-full bottom-0 flex justify-center bg-white py-3">
                    <Button
                      variant="contained"
                      sx={[
                        {
                          "&:hover": {
                            backgroundColor: "#ed113d !important",
                          },
                        },
                        {
                          width: "45%",
                          margin: 1,
                          backgroundColor: "#FF0000",
                        },
                      ]}
                      onClick={resetFiltersHanlder}
                    >
                      Reset
                    </Button>
                    <Button
                      sx={[
                        {
                          "&:hover": {
                            backgroundColor: "#b98f8f !important",
                          },
                        },
                        {
                          width: "45%",
                          margin: 1,
                          backgroundColor: "#B28585",
                        },
                      ]}
                      variant="contained"
                      onClick={handleApplyFilter}
                    >
                      Apply
                    </Button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </Dialog>
        </Transition.Root>

        <main className="mx-auto px-4 lg:px-14 mt-7">
          <div className="flex items-baseline justify-between border-b border-gray-200 pb-6">
            <h1 className="text-4xl font-bold tracking-tight text-[#b28585]">
              Products
            </h1>

            <div className="flex items-center">
              <Menu as="div" className="relative inline-block text-left">
                <div>
                  <Menu.Button className="group inline-flex justify-center text-sm font-medium text-gray-700 hover:text-gray-900">
                    Sort
                    <ChevronDownIcon
                      className="-mr-1 ml-1 h-5 w-5 flex-shrink-0 text-gray-400 group-hover:text-gray-500"
                      aria-hidden="true"
                    />
                  </Menu.Button>
                </div>

                <Transition
                  as={Fragment}
                  enter="transition ease-out duration-100"
                  enterFrom="transform opacity-0 scale-95"
                  enterTo="transform opacity-100 scale-100"
                  leave="transition ease-in duration-75"
                  leaveFrom="transform opacity-100 scale-100"
                  leaveTo="transform opacity-0 scale-95"
                >
                  <Menu.Items className="absolute right-0 z-10 mt-2 w-40 origin-top-right rounded-md shadow-2xl ring-1 ring-[#b28585]  bg-[#FFFBF2] ring-opacity-5 focus:outline-none">
                    <div className="py-1">
                      {sortOptions.map((option) => (
                        <Menu.Item key={option.name}>
                          {({ active }) => (
                            <p
                              onClick={() => handleSortChange(option.query)}
                              className={classNames(
                                option.current
                                  ? "font-medium text-gray-900"
                                  : "text-gray-500",
                                active ? "bg-gray-100" : "",
                                "block px-4 py-2 text-sm cursor-pointer"
                              )}
                            >
                              {option.name}
                            </p>
                          )}
                        </Menu.Item>
                      ))}
                    </div>
                  </Menu.Items>
                </Transition>
              </Menu>
              <button
                type="button"
                className="-m-2 ml-4 p-2 text-gray-400 hover:text-gray-500 sm:ml-6 lg:hidden"
                onClick={() => setMobileFiltersOpen(true)}
              >
                <span className="sr-only">Filters</span>
                <FunnelIcon className="h-5 w-5" aria-hidden="true" />
              </button>
            </div>
          </div>

          <section aria-labelledby="products-heading" className="pb-6 pt-6">
            <h2 id="products-heading" className="sr-only">
              Products
            </h2>

            <div>
              <h2 className="py-5 hidden font-semibold opacity-60 text-lg lg:block">
                Filters
              </h2>
              <div
                style={productGridStyle}
                // className="grid grid-cols-1 gap-x-8 gap-y-10 lg:grid-cols-5"
                className="grid grid-cols-1 gap-x-2 gap-y-10 md:grid-cols-3 lg:grid-cols-5 px-4 mb-10"
              >
                {/* Filters */}
                <form
                  className="hidden lg:block border p-5 h-max w-full lg:relative"
                  id="filter-form"
                  name="filter-form"
                >
                  {filters.map((section) => (
                    <Disclosure
                      // defaultOpen={false}
                      as="div"
                      key={section.id}
                      className="border-gray-200 py-6"
                      onClose={setMobileFiltersOpen}
                    >
                      {({ open }) => (
                        <>
                          <h3 className="-my-3 flow-root">
                            <Disclosure.Button className="flex w-full items-center justify-between py-3 text-sm text-gray-400 hover:text-gray-500">
                              <span className="font-medium text-gray-900">
                                {section.name}
                              </span>
                              <span className="ml-6 flex items-center">
                                {open ? (
                                  <MinusIcon
                                    className="h-5 w-5"
                                    aria-hidden="true"
                                  />
                                ) : (
                                  <PlusIcon
                                    className="h-5 w-5"
                                    aria-hidden="true"
                                  />
                                )}
                              </span>
                            </Disclosure.Button>
                          </h3>
                          <Disclosure.Panel className="pt-6">
                            <div className="space-y-4">
                              {section.id == "price" ? (
                                <Box sx={{}}>
                                  <Slider
                                    // getAriaLabel={() => "Temperature range"}
                                    value={priceRange}
                                    onChange={handleSliderChange}
                                    valueLabelDisplay="auto"
                                    size="small"
                                    sx={{ color: "#b28585" }}
                                    min={0}
                                    max={50000}
                                    // getAriaValueText={valuetext}
                                  />
                                  <div className="flex gap-2">
                                    <TextField
                                      id="min-price"
                                      name="min"
                                      variant="outlined"
                                      size="small"
                                      defaultValue={0}
                                      value={priceRange[0]}
                                      onChange={(e) => {
                                        setPriceRange([
                                          e.target.value,
                                          priceRange[1],
                                        ]);
                                      }}
                                    />
                                    <TextField
                                      id="max-price"
                                      hiddenLabel
                                      variant="outlined"
                                      size="small"
                                      defaultValue={50000}
                                      value={priceRange[1]}
                                      onChange={(e) => {
                                        setPriceRange([
                                          priceRange[0],
                                          e.target.value,
                                        ]);
                                      }}
                                    />
                                  </div>
                                </Box>
                              ) : (
                                section.options.map((option, optionIdx) => (
                                  <div
                                    key={option.value}
                                    className="flex items-center"
                                  >
                                    <input
                                      id={`filter-${section.id}-${optionIdx}`}
                                      name={`${section.id}[]`}
                                      defaultValue={option.value}
                                      type="checkbox"
                                      checked={newSelectedFilteres[
                                        section.id
                                      ].includes(option.value)}
                                      className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500 cursor-pointer"
                                      onChange={() =>
                                        handleFilter(option.value, section.id)
                                      }
                                    />

                                    <label
                                      htmlFor={`filter-${section.id}-${optionIdx}`}
                                      className="ml-3 text-sm text-gray-600"
                                    >
                                      {option.label}
                                    </label>
                                  </div>
                                ))
                              )}
                            </div>
                          </Disclosure.Panel>
                        </>
                      )}
                    </Disclosure>
                  ))}
                  {singleFilter.map((section) => (
                    <Disclosure
                      // defaultOpen={true}
                      as="div"
                      key={section.id}
                      className="border-gray-200 py-6 border-b"
                    >
                      {({ open }) => {
                        return (
                          <>
                            <h3 className="-my-3 flow-root">
                              <Disclosure.Button className="flex w-full items-center justify-between py-3 text-sm text-gray-400 hover:text-gray-500">
                                <span className="font-medium text-gray-900">
                                  {section.name}
                                </span>
                                <span className="ml-6 flex items-center">
                                  {open ? (
                                    <MinusIcon
                                      className="h-5 w-5"
                                      aria-hidden="true"
                                    />
                                  ) : (
                                    <PlusIcon
                                      className="h-5 w-5"
                                      aria-hidden="true"
                                    />
                                  )}
                                </span>
                              </Disclosure.Button>
                            </h3>

                            <Disclosure.Panel className="pt-6">
                              {/* <FormControl> */}
                              <RadioGroup
                                aria-labelledby="demo-radio-buttons-group-label"
                                defaultValue="female"
                                name="radio-buttons-group"
                              >
                                {section.options.map((option, optionIdx) => (
                                  <FormControlLabel
                                    sx={{
                                      padding: "0 12px",
                                      fontSize: "14px",
                                    }}
                                    value={option.value}
                                    control={
                                      <input
                                        name="stock"
                                        value={option.value}
                                        type="radio"
                                        checked={selectedFilters[
                                          section.id
                                        ].includes(option.value)}
                                        className="mr-2 h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                                      />
                                    }
                                    label={option.label}
                                    onChange={(e) =>
                                      handleFilter(e.target.value, section.id)
                                    }
                                    className="ml-3 min-w-0 flex-1 text-sm text-gray-500"
                                    // onChange={(e) =>
                                    //   handleRadioFilterChange(e, section.id)
                                    // }
                                  />
                                ))}
                              </RadioGroup>
                              {/* </FormControl> */}
                            </Disclosure.Panel>
                          </>
                        );
                      }}
                    </Disclosure>
                  ))}

                  <div className="flex w-full pt-1 text-sm mt-3 justify-between">
                    <Button
                      variant="contained"
                      sx={[
                        {
                          "&:hover": {
                            backgroundColor: "#ed113d !important",
                          },
                        },
                        {
                          width: "47%",
                          margin: "0 1",
                          backgroundColor: "#FF0000",
                          fontSize: "0.8rem",
                        },
                      ]}
                      onClick={resetFiltersHanlder}
                    >
                      Reset
                    </Button>
                    <Button
                      sx={[
                        {
                          "&:hover": {
                            backgroundColor: "#b98f8f !important",
                          },
                        },
                        {
                          width: "47%",
                          margin: "0 1",
                          backgroundColor: "#B28585",
                          fontSize: "0.8rem",
                        },
                      ]}
                      variant="contained"
                      onClick={handleApplyFilter}
                    >
                      Apply
                    </Button>
                  </div>
                </form>

                {/* Product grid */}

                {customersProduct?.products[`${query}`]?.content?.length <= 0 &&
                !customersProduct?.loading ? (
                  <div className="flex flex-col w-full items-center">
                    <img src="https://i.ibb.co/9szP4jH/Error404.webp" />
                    <Typography
                      variant="h6"
                      sx={{
                        marginBottom: 1,
                        fontSize: 15,
                        fontWeight: 600,
                      }}
                    >
                      Product Not Found!
                    </Typography>
                    <Typography
                      sx={{
                        marginBottom: 3,
                      }}
                    >
                      We could not find product you were looking up for.
                    </Typography>
                  </div>
                ) : (
                    <div className="grid grid-cols-2 col-span-4 gap-x-2 gap-y-10 md:grid-cols-3 lg:grid-cols-4 px-4 mb-10">
                      {customersProduct?.products[`${query}`]?.content?.map(
                        (item) => (
                          <HomeProductCard
                            product={item}
                            category={query}
                            view_all={view_all}
                          />
                        )
                      )}
                    </div>
                )}
              </div>
            </div>
          </section>
        </main>

        {/* pagination section */}
        {customersProduct?.products[`${query}`]?.content?.length > 0 && (
          <section className="w-full">
            <div className="py-5 flex justify-center border">
              <Pagination
                variant="outlined"
                sx={{
                  color: "#b28585",
                }}
                onChange={handlePaginationChange}
                defaultPage={1}
                page={selectedPageNo}
                // count={10}
                count={customersProduct?.products[`${query}`]?.totalPages}
                renderItem={(item) => (
                  <PaginationItem
                    slots={{ previous: ArrowBackIcon, next: ArrowForwardIcon }}
                    {...item}
                  />
                )}
              />
            </div>
          </section>
        )}

        {/* {backdrop} */}
        <section>
          <BackdropComponent open={isLoaderOpen} />
        </section>
      </div>
    </div>
  );
}
